<script>
import EventBus from '../utils/EventBus'
import disclosure from '../utils/disclosure'

import DisclosureTransition from './DisclosureTransition'

export default {
  inject: { disclosure },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    disclosureId: {
      type: String,
      required: true,
    },
    mode: {
      type: String,
      default: 'show',
      validate: value => ['if', 'show'].includes(value),
    },
  },

  data() {
    return {
      expanded: false,
    }
  },

  computed: {
    isExpanded() {
      return !this.disclosure.expanded.includes(this)
    },
  },

  watch: {
    expanded() {
      this.disclosure.$emit('created:active', this)
    },
  },

  created() {
    EventBus.$on('toggle', this.toggle)
    EventBus.$emit('created:container', this.disclosureId)
    this.$on('collapse', (item) => {
      if (item.expanded) {
        EventBus.$emit('force:toggle', this.disclosureId)
      }
    })
    this.disclosure.$emit('created:disclosure', this)
  },

  methods: {
    toggle({ controls, expanded }) {
      if (controls === this.disclosureId) {
        this.expanded = expanded
      }
    },
    createChild(createElement, elementData) {
      if (!(this.mode === 'show' || this.expanded)) {
        return undefined
      }

      return createElement(DisclosureTransition, [
        createElement(this.tag, elementData, this.$slots.default),
      ])
    },
  },
  render(createElement) {
    const { expanded } = this
    const elementData = {
      attrs: {
        id: this.disclosureId,
      },
      class: { expanded },
    }

    if (this.mode === 'show') {
      elementData.directives = [
        {
          name: 'show',
          value: expanded,
        },
      ]
    }

    return this.createChild(createElement, elementData)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/DisclosureContent.vue